import { render, staticRenderFns } from "./ConfirmationBox.vue?vue&type=template&id=125d249a&scoped=true"
import script from "./ConfirmationBox.vue?vue&type=script&lang=js"
export * from "./ConfirmationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d249a",
  null
  
)

export default component.exports